"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KTR = exports.KeepTheRhythmComponent = void 0;
const app_1 = require("app");
const webexUI_1 = require("webexUI");
class KeepTheRhythmComponent extends app_1.Component {
    //  TODO: At least some of the following classes should be removed from the codebase along with the component itself
    // '.ktr, .half-ktr, .cta--large, .cta--small, .grid-danf-fe-rte img, .grid-danf-fe-rte table:not([class])';
    constructor() {
        super();
        // + .ktr-padding if padding instead of margin
        this.selector = '';
        this.skipInitIfNotOnPage = false;
    }
    OnInit() {
        this.FixTheRhythmElements(this.el);
    }
    OnWindowResizeThrottle() {
        this.FixTheRhythmElements(this.el);
    }
    OnInstancesUpdated() {
        this.FixTheRhythmElements(this.el);
    }
    GetMissingRhythm(height, rhythmHeight) {
        let rhythm = rhythmHeight - (height % rhythmHeight);
        if (rhythm === rhythmHeight) {
            rhythm = 0;
        }
        return rhythm;
    }
    FixTheRhythmElements(el) {
        el.forEach(elem => this.FixTheRhythm(elem));
    }
    FixTheRhythm(element) {
        const $el = $(element);
        if ($el.is('img') && (0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.LGScreen)) {
            this.clampContainerContent(element); // clamping container text proportional to the number of lines
        }
        if (element.closest('.no-ktr')) {
            return;
        }
        const parent = element.closest('div'), el = parent.classList.contains('bordered') ? parent : element, height = this.GetElementHeight($el), rhythmHeight = el.classList.contains('half-ktr')
            ? Math.floor(KeepTheRhythmComponent.baseline / 2)
            : KeepTheRhythmComponent.baseline, rhythm = this.GetMissingRhythm(height, rhythmHeight);
        let bottom = rhythm;
        let style = 'marginBottom';
        if (el.classList.contains('ktr-padding')) {
            style = 'paddingBottom';
        }
        if (el.classList.contains('ktr--not_zero')) {
            bottom = bottom !== 0 ? bottom : KeepTheRhythmComponent.baseline;
        }
        el.style[style] = `${bottom}px`;
        if ($el.is('img')) {
            const $picture = $el.parent('picture');
            this.fixTheImageContainerItems($picture, bottom);
        }
        if ($el.is('img') && !element.classList.contains('lazyloaded')) {
            element.addEventListener('load', () => {
                this.FixTheRhythm(element);
                $el.off('load');
            });
        }
    }
    fixTheImageContainerItems($el, bottom) {
        const isMobile = (0, webexUI_1.detectBreakpoint)(webexUI_1.Breakpoint.UpToTablet);
        const marginTop = 'margin-top';
        const spotPlayVideoButton = $el.next('.cta--play-video');
        if (isMobile || !spotPlayVideoButton.hasClass('adjust-to-center')) {
            spotPlayVideoButton.css(marginTop, `-${bottom / 2}px`);
        }
    }
    clampContainerContent(el) {
        const $el = $(el);
        const baseline = KeepTheRhythmComponent.baseline;
        const $picture = $el.parent('picture');
        const $spot = $picture.closest('.spot-two_plus_one');
        const isSideContainer = $spot.parent('.side-container').length;
        const $spotContentContainer = $spot.find('.spot-content-container');
        const containerHeight = $spotContentContainer.height();
        const titleHeight = $spotContentContainer.find('.spot-content__title').outerHeight();
        const $innerContainer = $spotContentContainer.find('.spot-content-container-inner');
        const bodyClassNames = document.body.classList;
        const isIEOrEdge = bodyClassNames.contains('ie-active') || bodyClassNames.contains('edge-active');
        if (!isSideContainer) {
            return;
        }
        if (!el.classList.contains('lazyloaded')) {
            $el.on('lazyloaded', () => {
                if (isIEOrEdge) {
                    setTimeout(() => {
                        this.clampContainerContent(el);
                    }, 300);
                }
                else {
                    this.clampContainerContent(el);
                }
                $el.off('load');
            });
        }
        if (titleHeight >= containerHeight - baseline) {
            const containerLines = Math.floor(containerHeight / baseline);
            $innerContainer.css('height', containerLines * baseline + 'px');
        }
        else {
            const descriptionHeight = containerHeight - titleHeight - baseline / 2; // description text top-margin = 12px
            const descriptionContainerLines = Math.floor(descriptionHeight / baseline);
            $innerContainer.css('height', `${descriptionContainerLines * baseline + titleHeight + baseline / 2}px`);
        }
    }
    GetElementHeight($el) {
        if ($el.hasClass('ktr-padding')) {
            // compute height without paddings, border, margins
            return Number(window.getComputedStyle($el[0], null).getPropertyValue('height'));
        }
        return ($el.outerHeight() ||
            $el.parent().outerHeight() ||
            $el[0].height);
    }
}
exports.KeepTheRhythmComponent = KeepTheRhythmComponent;
KeepTheRhythmComponent.baseline = 24;
const KTR = new KeepTheRhythmComponent();
exports.KTR = KTR;
